import { render } from "./FooterWeb.vue?vue&type=template&id=702c6a0c"
import script from "./FooterWeb.vue?vue&type=script&lang=js"
export * from "./FooterWeb.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/rg-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__